import { render, staticRenderFns } from "./UploadBhp.vue?vue&type=template&id=55f1b6f2&"
import script from "./UploadBhp.vue?vue&type=script&lang=js&"
export * from "./UploadBhp.vue?vue&type=script&lang=js&"
import style0 from "./UploadBhp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports